module.exports = __webpack_public_path__ + "static/img/dlogo.39f8438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlogo.png
// module id = LwjX
// module chunks = 12